import styled from "styled-components";

import { MovieDetailPlaceholderStyledProps as Props } from "./MovieDetailPlaceholder.types";
import CONSTANTS from "config/constants";

const { mobile } = CONSTANTS.BREAKPOINTS;

const MovieDetailPlaceholderStyled = styled.div<Props>`
  display: flex;
  flex: 1;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;

  .MovieDetailPlaceholder {
    &__card {
      margin-bottom: 3.2rem;
      width: 51%;

      @media (max-width: ${mobile}px) {
        width: 100%;
      }
    }

    &__image {
      height: 28rem;
      border-radius: 0.4rem;
    }

    &__modality {
      width: 12rem;
      height: 2.4rem;
      margin-top: 3.2rem;
      border-radius: 0.8rem;
    }

    &__language {
      width: 6.4rem;
      margin: 0.4rem 0;
      height: 1.6rem;
      border-radius: 0.8rem;
    }
  }
`;

export default MovieDetailPlaceholderStyled;
